module.exports = __webpack_public_path__ + "img/TasksUser1.1abde6d2.png";